<template>
  <div>
    <div class="doctorPage doctorSeach managerPlan">
      <div class="selectSearch">
        <el-tabs class="fileUpTabs" v-model="tabName" @tab-click="handleClick">
          <el-tab-pane label="评分标准" name="first">评分标准</el-tab-pane>
          <el-tab-pane label="患者信息" name="second">患者信息</el-tab-pane>
        </el-tabs>
        <div v-if="tabName == 'first'">
          <el-form ref="form" :model="appealParameter" class="qcFrom" :inline="true">
            <el-form-item label="关键词">
              <el-input v-model="appealParameter.key" class="name" placeholder="请输入关键词" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="appealParameter.state" placeholder="请选择状态" size="mini" class="name">
                <el-option label="全部" :value="-1"></el-option>
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="appealParameter.scoreType" placeholder="请选择类型"  @change="typeChange" size="mini" class="name">
                <el-option label="报告" :value="1"></el-option>
                <el-option label="影像" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search" round>查询</el-button>
              <el-button type="primary" class="resetBtn" @click="resetForm('form')">重置</el-button>
            </el-form-item>
            <el-form-item class="rightBtn">
              <el-button type="primary" @click="addList" round style="background:#2eb4b5 !important">
                添加{{typeName}}
              </el-button>
            </el-form-item>
          </el-form>
          <div class="centerHome" v-loading="standardLoading">
            <div class="ccHomel">
              <div class="compentTable">
                <el-table class="qcTable" :data="standardList" v-loading="loading">
                  <el-table-column type="index" label="序号" width="80"></el-table-column>
                  <el-table-column prop="Name" label="科目名称" min-width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="ViewMode" label="查看方式" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="MarkingScheme" label="扣分标准" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="CriterionPoint" label="标准评分" sortable min-width="100"></el-table-column>
                  <el-table-column prop="AvailablePoint" label="本项可扣分值" min-width="120">
                    <template slot-scope="scope">
                      <div>
                        {{JSON.stringify(scope.row.AvailablePoint).replace(/^\[|\]$/g, "")}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="State" label="状态">
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.State ? "启用" : "禁用" }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="CreatedName" label="操作人"></el-table-column>
                  <el-table-column prop="CreateTime" label="操作时间" sortable min-width="160"></el-table-column>
                  <el-table-column prop="" label="操作" width="180">
                        <template slot-scope="scope">
                          <span class="tableOpe marr15" @click="editClick(scope.row)">编辑</span>
                          <span class="tableOpe textColorRed" @click="del(scope.row)">删除</span>
                        </template>
                      </el-table-column>
                </el-table>
                <div class="pages">
                  <el-pagination
                    class="pageAll"
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="appealParameter.pageSize"
                    :current-page="appealParameter.pageIndex"
                    @current-change="currentChange"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else v-loading="patientLoading">
          <el-button type="primary" @click="addpatient" round>
            添加
          </el-button>
          <ul class="mart25 patientLi" :style="{height:height+'px'}">
              <li v-for="item in filteredPatientList" :key="item.Id" class="patientBox">
                <el-switch v-model="item.State" class="marr15" @change="switchChange(item)"></el-switch>
                <span class="patientText">{{item.Name}}</span>
                  <span class="btnCss" style="float:right;cursor: pointer;" v-if="item.IsAllowedDel">
                    <span @click="infoEdit(item)">
                      <svg-icon class="fz14 marr5" icon-class="icon_edit"></svg-icon>
                    </span>
                    <span @click="infoDel(item)">
                    <svg-icon class="fz14" icon-class="icon_delete"></svg-icon>
                    </span>
                  </span>
              </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog :title="'添加'+typeName" :visible.sync="dialogVisible" width="60%" class="dialogVisible offline">
      <el-form ref="scoreform" :rules="scoreRules" :model="addParameter" :inline="true">
        <el-row>
          <el-col :span="12">
            <el-form-item label="科目名称" prop="Name">
              <el-input v-model="addParameter.Name" class="name" placeholder="请输入科目名称" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="扣分标准" prop="MarkingScheme">
              <el-input
                v-model="addParameter.MarkingScheme"
                class="name"
                placeholder="请输入扣分标准"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="state"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="查看方式" prop="ViewMode">
              <el-input
                v-model="addParameter.ViewMode"
                class="name"
                placeholder="请输入查看方式"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="标准分值" prop="CriterionPoint">
              <el-input
                v-model="addParameter.CriterionPoint"
                class="name"
                placeholder="请输入标准分值"
                type="number"
                size="mini"
                @blur="(e) => {blurNumber(e)}"
              ></el-input>
            </el-form-item>
            <el-form-item label="可扣分值" prop="AvailablePoint">
              <el-select size="small" v-model="addParameter.AvailablePoint" placeholder="请选择可扣分值" multiple>
                <el-option v-for="item in 30" :key="item" :label="item" :value="item"></el-option>
                <el-option :key="50" :label="50" :value="50"></el-option>
                <el-option :key="100" :label="100" :value="100"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="projectAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="患者信息" :visible.sync="patientVisible" width="60%" class="dialogVisible offline">
      <el-form ref="infoform" :rules="infoRules" :model="patientParameter" :inline="true">
        <el-row>
          <el-form-item label="患者信息名称" prop="Name">
            <el-input v-model="patientParameter.Name" class="name" placeholder="请输入患者信息名称" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="字段类型" v-if="statsShow" prop="Type">
            <el-select v-model="patientParameter.Type" placeholder="请选择字段类型" size="mini" class="name">
              <el-option label="文本" value="input"></el-option>
              <el-option label="时间" value="date"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" style="width:100%" v-if="statsShow">
            <el-switch v-model="patientParameter.State"></el-switch>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="patientVisible = false">取 消</el-button>
        <el-button type="primary" @click="patientAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api/index.js";
import axios from "@/js/api";
export default {
  data() {
    return {
      infoRules:{
					Name: [{
						required: true,
            message: '请输入患者信息名称',
						trigger: 'blur'
					}, ],
					Type: [{
						required: true,
            message: '请输入字段类型',
						trigger: 'change'
					},],
      },
      scoreRules:{
					Name: [{
						required: true,
            message: '请输入科目名称',
						trigger: 'blur'
					}, ],
					// ViewMode: [{
					// 	required: true,
          //   message: '请输入查看方式',
					// 	trigger: 'blur'
					// }, ],
					// MarkingScheme: [{
					// 	required: true,
          //   message: '请输入扣分标准',
					// 	trigger: 'blur'
					// }, ],
					CriterionPoint: [{
						required: true,
            message: '请输入标准分值',
						trigger: 'blur'
					}, ],
					AvailablePoint: [{
						required: true,
            message: '请选择可扣分值',
						trigger: 'change'
					}, ],
      },
      appealParameter: {
        scoreType: 1,
        state: -1,
        key: "",
        pageIndex: 1,
        pageSize: 10,
      },
      tabName: "first",
      loading: false,
      totalCount: 0,
      listParameter: {},
      patientKey: [],
      dialogVisible: false,
      standardLoading: false,
      standardList: [],
      addParameter: {
        State: true,
        CriterionPoint:0
      },
      patientList: [
        {
          type: 1,
          name: "病例号",
        },
      ],
      patientLoading: false,
      patientVisible: false,
      state:true,
      patientListitem:[],
      patientParameter:{
          Name:'',
          State:true,
          Type:'input'
      },
      height:0,
      typeName:'报告',
      statsShow:false
    };
  },
  computed: {
    filteredPatientList() {
      return this.patientListitem.filter(item => item.Name !== '报告得分' && item.Name !== '影像得分');
    }
  },
  activated() {
    var viewportHeight = window.innerHeight;
    this.height = viewportHeight - 340;
    this.standardsList();
  },
  methods: {
    blurNumber(e, name) {
      if (!e.target.value) {
        this.addParameter.CriterionPoint = 0
      }
    },
    infoEdit(item){
      this.patientVisible = true;
      this.statsShow = false;
      this.patientParameter = JSON.parse(JSON.stringify(item))
    },
    switchChange(item){
        this.patientParameter = item
        axios.ajaxPost('post', Api.api.scene.patientStateEdit,this.patientParameter).then(res => {
            _this.patientLists();
        });
    },
    editClick(item){
      this.dialogVisible = true
      this.addParameter = JSON.parse(JSON.stringify(item))
    },
    infoDel(item){
      let _this = this;
      this.patientParameter = item
      this.$confirm('是否确定删除该信息名称？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
          axios.ajaxPost('post', Api.api.scene.patientDel,this.patientParameter).then(res => {
            if (res.data.StatusCode == 200) {
                _this.$message.success("删除成功")
                _this.patientLists();
            }else{
              _this.$message.error(res.data.Msg)
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    del(item){
      let _this = this;
      this.addParameter = item
      this.$confirm('是否确定删除该标准？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
          axios.ajaxPost('post', Api.api.scene.imagesDelete,this.addParameter).then(res => {
              if (res.data.StatusCode == 200) {
                _this.$message.success("删除成功")
                _this.standardsList();
            }else{
              _this.$message.error(res.data.Msg)
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      this.standardsList();
    },
    typeChange(val){
        this.typeName = val == 1?'报告':'影像'
    },
    patientLists(){
      this.patientLoading = true;
      axios.ajaxGet("get", Api.api.scene.patientList).then((res) => {
        this.patientListitem = res.data.Data;
        this.patientLoading = false;
      });
    },
    patientAdd(){
      this.$refs.infoform.validate((valid) => {
        if (valid) {
      if (this.patientParameter.UniqueId) {
          axios.ajaxPost('post', Api.api.scene.patientEdit,this.patientParameter).then(res => {
              this.patientVisible = false;
              this.patientLoading = false
              this.$message.success("修改成功")
              this.patientLists();
          });
      }else{
          this.patientLoading = true
          let sort = this.patientListitem.length<=0?1:this.patientListitem.length + 1
          this.patientParameter.Sort = sort
          axios.ajaxPost("post", Api.api.scene.patientAdd, this.patientParameter).then((res) => {
              this.patientVisible = false;
              this.patientLoading = false
              this.patientLists();
          });
      }
        } else {
          return false;
        }
      });

    },
    projectAdd() {
      				this.$refs.scoreform.validate((valid) => {
					if (valid) {
      this.addParameter.State = this.state
      if (this.addParameter.UniqueId) {
          axios.ajaxPost("post", Api.api.scene.imagesEdit, this.addParameter).then((res) => {
            this.standardsList();
            this.dialogVisible = false;
          });
      }else{
        this.addParameter.ScoreCriteriaUid = this.appealParameter.uid;
        this.addParameter.ScoreType = this.appealParameter.scoreType;
        this.addParameter.Sort = this.standardList.length<=0?1:this.standardList.length + 1
        axios.ajaxPost("post", Api.api.scene.imagesAdd, this.addParameter).then((res) => {
          this.standardsList();
          this.dialogVisible = false;
        });
      }
					} else {
						return false;
					}
				});

    },
    standardsList() {
      this.standardLoading = true;
      axios.ajaxGet("get", Api.api.scene.imagesList, this.appealParameter).then((res) => {
        this.standardList = res.data.Data;
        this.standardLoading = false;
      });
    },
    resetForm() {
      this.appealParameter = {
        scoreType: 1,
        state: -1,
        key: "",
        pageIndex: 1,
        pageSize: 10,
        uid:this.appealParameter.uid
      }
      this.search()
    },
    handleClick(tab, event) {
        if (event.target.innerText == '患者信息') {
            this.patientLists();
        }
    },
    search() {
        this.currentChange(1);
    },
    currentChange(val) {
      this.appealParameter.pageIndex = val
	  this.standardsList()
    },
    addList() {
      this.dialogVisible = true;
      this.state = true;
      this.addParameter = {
        Name:'',
        MarkingScheme:'',
        State:true,
        ViewMode:'',
        CriterionPoint:0,
        AvailablePoint:[]
	    }
    },
    addpatient() {
      this.patientVisible = true;
      this.statsShow = true;
      this.patientParameter={
          Name:'',
          State:true,
          Type:'input'
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";
.offline .el-input__inner{
    @include bg-color(dialogareai);
    @include text-color(fzColori);
}
.fileUpTabs .el-tabs__nav {
  padding-bottom: 10px;
}
.fileUpTabs .el-tabs__nav-wrap::after {
  background-color: #4e5262;
  height: 1px;
}
.fileUpTabs .el-tabs__item.is-active {
  color: #248afd;
}
.fileUpTabs .el-tabs__active-bar {
  background-color: #248afd;
}
.fileUpTabs .el-tabs__item {
  // @include text-color(fzColor);
  color: #c4c4c4;
  font-weight: 400;
}
.fileUpTabs .el-tabs__content {
  display: none;
}
</style>
<style lang="scss" scoped="scoped">
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";
.offline .el-input__inner{
    @include bg-color(dialogareai);
    @include text-color(fzColori);
}
.patientLi{
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start; 
}
.patientBox{
    padding: 16px;
    border-radius: 6px;
    // @include bg-color(dialogareai);
    @include bg-color(htmlBg);
    @include text-color(fzColori);
    // color: #fff;
    margin:10px 15px;
    font-size: 14px;
    width: 260px;
}
.rightBtn {
  position: absolute;
  right: 0;
}
.table-task-btn {
  width: 25%;
}
.text-container {
  white-space: pre-wrap;
}
.el-dialog__body {
  // color: #fff;
  @include text-color(fzColor);
  max-height: 700px;
}
.sheetData h2 {
  margin: 10px 0;
  font-size: 14px;
}
.sheetData table {
  border: 1px solid #fff;
}

.sheetData {
  border-collapse: collapse;
  width: 100%;
}

.sheetData th,
.sheetData td {
  border-right: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.sheetData tr {
  border: 1px solid #ddd;
}
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
table {
  width: 100%;
  margin: auto;
}
.pdf-container {
  width: 100%;
}
.el-button-group {
  left: 50% !important;
}
.el-dialog .el-form-item__label {
  font-size: 15px;
}
.managerPlan .selectSearch {
  display: block;
}
.managerPlan .selectSearch .addbtn {
  right: 18px;
  top: 73%;
}
</style>
